import { Component, OnInit } from '@angular/core';
import { GridviewComponent } from '../gridview/gridview.component';
import { ToastrService } from 'ngx-toastr';
import { ProgressbarComponent } from '../progressbar/progressbar.component';
import {LoginService} from '../login.service';
import { HttpEventType,HttpResponse,HttpRequest,HttpClient } from '@angular/common/http';
import { Router,RouterModule} from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-correspondence',
  templateUrl: './correspondence.component.html',
  styleUrls: ['./correspondence.component.scss']
})
export class CorrespondenceComponent implements OnInit {
  fileToUpload: File = null;
  filestoUpload=[];
  private gridApi;
  private uploadgridApi;
  private gridColumnApi;
  private uploadgridColumnApi;
  public context;
  public deleteData:any;
  public frameworkComponents;
  tabToNextCell:any;
  selectedType:any = 'Employment Plan';
  uploadSwitch:any = 'No';
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [
    {headerName: 'Document ID', field: 'id' },
    {headerName: 'Document Type', field: 'doc_type' },
    {headerName: 'Uploaded Date', field: 'uploaded_dt'},
    {headerName: 'Uploaded By', field: 'uploaded_by'},
    {headerName: 'Action', field: 'path',cellRenderer:'viewrenderer'}
];
uploadcolumnDefs = [
  {headerName: 'File Name', field: 'name' },
  {headerName: 'Size', field: 'size' },
  {headerName: 'Progress', field: 'progress',cellRenderer:'progressrenderer'},
];
filedetails = [];

rowData = [];
task = {
  perId:this.loginService.personId,
  notes:null,
  startDate:new Date().getFullYear() + '-' + (new Date().getMonth()+1) + '-'+ new Date().getDate(),
  dueDate:null,
  taskType:'DU'
}

  constructor(public toastService:ToastrService,public http:HttpClient, public loginService:LoginService, public router:Router) { }

  ngOnInit() {
    this.context = {
      componentParent:this
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellPosition;
      const prevCell = params.previousCellPosition;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action' || (prevCell.column.colDef.headerName === 'Action' && (nextCell.rowIndex !== prevCell.rowIndex ) && nextCell.column.colDef.headerName == 'Document ID')) {
        return;
      } else {
      return nextCell;
      }
      }; 
    this.frameworkComponents = {
      viewrenderer: GridviewComponent,
      progressrenderer:ProgressbarComponent
    };
    this.load();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  onuploadGridReady(params) {
    this.uploadgridApi = params.api;
    this.uploadgridColumnApi = params.columnApi;
    this.uploadgridApi.sizeColumnsToFit();
    //this.uploadgridApi.setDomLayout("autoHeight");
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    if(((this.fileToUpload.size/1024)/1024) > 5){
      this.toastService.error("File size exceeds maximum limit","My Documents");
    }
    else if(this.fileToUpload.type === 'application/pdf' || this.fileToUpload.type === 'image/jpeg' || this.fileToUpload.type === 'image/png'){
      this.filestoUpload.push(this.fileToUpload);
      let file={
        name:this.fileToUpload.name,
        uploaded_dt:(new Date().getMonth()+1) + '/'+new Date().getDate() + '/' + new Date().getFullYear(),
        size:((this.fileToUpload.size/1024)/1024).toFixed(2)+'MB',
        progress:0,
        doc_type:this.selectedType,
        uploaded_by:this.loginService.firstName + ' ' + this.loginService.lastName,
        person_id:this.loginService.personId
      }
      this.filedetails.push(file);
      this.uploadgridApi.setRowData(this.filedetails);
    }
    else{
      this.toastService.error("File type is not supported to upload","My Documents");
    }
}
upload(){
  let formData = new FormData();
  if(this.filestoUpload.length == 0){
    this.toastService.error("No files selected to upload", "My Documents");
  }
  else{
    for(let i =0; i < this.filestoUpload.length; i++){
      formData.append("files", this.filestoUpload[i], this.filestoUpload[i]['name']);
    }
    const req = new HttpRequest('POST', this.loginService.serverConst+ '/fileUpload', formData, {
      reportProgress: true,
    });
    this.http.request(req).subscribe(event => {
      // Via this API, you get access to the raw event stream.
      // Look for upload progress events.
      if (event.type === HttpEventType.UploadProgress) {
        // This is an upload progress event. Compute and show the % done:
        const percentDone = Math.round(100 * event.loaded / event.total);
        this.filedetails.forEach((element)=>{
          element.progress = percentDone;
        })
        this.uploadgridApi.setRowData(this.filedetails);
      } else if (event instanceof HttpResponse) {
        this.filestoUpload = [];
        this.save(event);
        //this.toastService.success("Succesfully uploaded file","My Documents");
      }
    },error=>{
      this.toastService.error("Record not saved: Please review or contact Help Desk", "My Documents");
    });
  }
}
save(event){
  event.body["data"].forEach((element)=>{
    this.filedetails.forEach((element2)=>{
      if((element.originalname == element2.name)&& (element2.size == (((element.size/1024)/1024).toFixed(2)+'MB'))){
        element2.path = element.filename;
      }
    })
  });
  this.filedetails.forEach((element)=>{
    this.loginService.saveDocuments(element).subscribe((data)=>{
      $("#closeConfirm").click();
      if(data["message"] == 'success'){
        this.toastService.success("File saved successfully","My Documents");
        this.filedetails = this.filedetails.filter(function( obj ) {
          return ((obj.name !== element.name) && (obj.size != element.size));
        });
        this.uploadgridApi.setRowData(this.filedetails);
        this.saveTask();
      }
      else{
        this.toastService.error("Record not saved: Please review or contact Help Desk", "My Documents");
      }
    },error=>{
      this.toastService.error("Record not saved: Please review or contact Help Desk", "My Documents");
    })
  });
  this.load();
}
load(){
  let request = {
    perId:this.loginService.personId,
    type:'UP'
  };
  this.loginService.loadDocuments(request).subscribe((data:Array<Object>)=>{
    this.rowData = data;
  },error=>{
    this.toastService.error("Unable to load files", "My Documents");
  })
}
saveTask(){
    this.task.dueDate = this.loginService.staticData.get("TASKDUEDATES").find(obj => obj.value == 'DU').name;
    this.loginService.saveTask(this.task).subscribe((data)=>{
      if(data['message']=='success'){
        this.toastService.success('Successfully created task','My Documents');
      }
      else{
        this.toastService.error('Record not saved: Please review or contact Help Desk','My Documents');
      }
    },error=>{
      this.toastService.error('Record not saved: Please review or contact Help Desk','My Documents');
    })
}
delete(event){
  this.deleteData = event.data;
}
confirmdelete(){
  let arr =[];
  arr.push(this.deleteData)
  let request = this.deleteData;
  this.loginService.saveDocuments(request).subscribe((data)=>{
    if(data["message"] == 'success'){
      $("#deleteClose").click();
      this.load();
      this.toastService.success("File deleted successfully","My Documents");
    }
    else{
      this.toastService.error("Record not saved: Please review or contact Help Desk", "My Documents");
    }
  },error=>{
    this.toastService.error("Record not saved: Please review or contact Help Desk", "My Documents");
  });
}
focus(event){
  if(event.keyCode == 9){
    this.gridApi.ensureIndexVisible(this.gridApi.paginationGetCurrentPage()*10);
    let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
      return;
    }
    else{
      event.preventDefault();
      this.gridApi.setFocusedCell((this.gridApi.paginationGetCurrentPage()*10), firstCol);
    }
  }
  else{
    return;
  }
}
focus1(event){
  if(event.keyCode == 9){
    this.uploadgridApi.ensureIndexVisible(0);
    let firstCol = this.uploadgridColumnApi.getAllDisplayedColumns()[0];
    this.uploadgridApi.ensureColumnVisible(firstCol);
    if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
      return;
    }
    else{
      event.preventDefault();
      this.uploadgridApi.setFocusedCell(0, firstCol);
    }
  }
  else{
    return;
  }
}

}



// WEBPACK FOOTER //
// ./src/app/correspondence/correspondence.component.ts